const recommendationHiddenBlock = document.getElementById(
	'recommendationHiddenBlock'
)

function OpenRecommendationBlock() {
	recommendationHiddenBlock.style.display = 'block'
}

function CloseRecommendationBlock() {
	recommendationHiddenBlock.style.display = 'none'
}
